import React, {useState, useEffect} from 'react';
import {Link} from 'gatsby';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {buildImageUrl, formatDate, parseNameToUrl} from '~utils/helper';
import Plus from '~components/icons/plus';
import {generatePrice} from '~utils/com-helper';
import Favorite from '~components/icons/favorite';
import {post, remove} from '~utils/api';
import {shortDateFormat} from '~constants/product-detail';

import './styles.scss';
import {isShowPriceByDate} from '~utils/price-helper';
import {offerLines} from '~utils/rental-offer';

const ProductItem = ({item, isPromotion, isFirst, isLast, favoritePage, removeFavorite, updateCategoryState}) => {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    setProduct(item);
  }, [item]);

  const handleAddCart = () => {
    console.log('Added cart');
  };

  const handleAddFavorite = async () => {
    if (favoritePage) {
      removeFavorite && removeFavorite(product.id);
      return;
    }

    product.isLike
      ? await remove('/v1/product/favorite-product', {id: product.id})
      : await post('/v1/product/favorite-product', {id: product.id});

    setProduct({...product, isLike: !product.isLike});
  };

  const linkToProductInfo = () => {
    if (updateCategoryState) updateCategoryState();
  };

  const getDeliveryTitle = (title, startDate, endDate) => {
    if (!startDate || !endDate) return title;
    return `${title} (${formatDate(startDate, shortDateFormat)} - ${formatDate(endDate, shortDateFormat)})`;
  };

  const showDeliveryTitle = item => {
    const deliveryTitles = [];
    if (isShowPriceByDate(item, 'isSgDeliveryEnabled')) {
      deliveryTitles.push(getDeliveryTitle('Giao trong SG', item.sgDeliveryStartDate, item.sgDeliveryEndDate));
    }
    if (isShowPriceByDate(item, 'isSgHolidayDeliveryEnabled')) {
      deliveryTitles.push(
        getDeliveryTitle('Giao trong SG Lễ-Tết', item.sgHolidayDeliveryStartDate, item.sgHolidayDeliveryEndDate)
      );
    }

    return deliveryTitles.length > 0 ? (
      <div className='item-price delivery-note'>{deliveryTitles.join('/')}</div>
    ) : undefined;
  };

  return (
    <div className='product-item' style={{marginLeft: isFirst ? '0' : '5px', marginRight: isLast ? '0' : '5px'}}>
      <div className={`favorite-area ${product?.isLike ? 'favorited' : ''}`} onClick={handleAddFavorite}>
        <div className='favorite-icon'>
          <Favorite fill='white' size={16} />
        </div>
      </div>
      <Link to={`/product/${parseNameToUrl(product?.name || '')}.prod.${product?.id || 0}`} onClick={linkToProductInfo}>
        <div className='product-image'>
          <LazyLoadImage
            key={item.id}
            src={buildImageUrl(item.primaryImageUrl, '208x308')}
            alt={item.name}
            title={item.name}
            width={208}
            height={308}
          />
          <div hidden={!item.isComing} className='coming-soon'>
            <div className='label'>Hàng sắp về</div>
          </div>
          <div hidden={!item.isHot} className='hot-product'>
            <div className='label'>HOT</div>
          </div>
        </div>
        <div className='item-content'>
          <div className='item-title' title={item.name}>
            {item.name}
          </div>
          {isPromotion && (
            <div className='promotion'>
              <span className='promotion-icon'>{item.promotion || 20}% Off</span>
              <span className='total-sale'>Đã bán: {item.totalSale || 0}</span>
            </div>
          )}
          <div className='item-price'>Hãng: {generatePrice(item.originalPrice)}</div>
          {item.isRentEnabled && (
            <div className='item-price item-rental'>
              Thuê: {generatePrice(item.originalRentalPrice, item.rentalPrice)}
            </div>
          )}
          {isShowPriceByDate(item, 'isRent1DayEnabledOutside') && (
            <div className='item-price item-rental'>Thuê SG: {generatePrice(item.rent1DayPrice)}</div>
          )}
          {isShowPriceByDate(item, 'isProvinceRentEnabledOutside') && (
            <div className='item-price item-rental'>Thuê Tỉnh: {generatePrice(item.provinceRentPrice)}</div>
          )}
          {isShowPriceByDate(item, 'isProvinceMembershipRentEnabledOutside') && (
            <div className='item-price item-rental'>Tỉnh (Gói): {generatePrice(item.provinceMembershipRentPrice)}</div>
          )}
          {isShowPriceByDate(item, 'isHolidayRentEnabledOutside') && (
            <div className='item-price item-rental'>Tết ÂL: {generatePrice(item.holidayRentPrice)}</div>
          )}
          {offerLines(item).map(line => (
            <div className='item-price item-rental' key={line.key}>
              {line.label}: {generatePrice(line.price)}
              {line.shipping ? ` (${line.shipping})` : ''}
            </div>
          ))}
          {/* {showDeliveryTitle(item)} */}
          {item.isMoreInfoOutside && (
            <div className='item-price membership'>{item.moreInfoOutside.trim().replace(/\n+/g, '\n')}</div>
          )}

          {/* {item.membershipRentalPrice ? (
            <div className='item-price item-rental'>Membership: {toVND(item.membershipRentalPrice)}</div>
          ) : (
            <div className='item-price membership'>{membershipTitle}</div>
          )} */}
        </div>
      </Link>
      <div className='add-cart' onClick={handleAddCart}>
        <div className='icon'>
          <div className='p-icon'>
            <Plus size='16' fill='#ffffff' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
